// styles
import classes from './styles.module.css';

export default function NoAccess() {
  return (
    <div className={classes.root}>
      <div className={classes.box}>
        <h2>Нет доступа</h2>
      </div>
    </div>
  )
}